import { BRANCH_APPLICATIONS_ERROR, BRANCH_APPLICATIONS_LOADER, GET_ALL_ACTIVE_BRANCHES, GET_APPLICATIONS_SUMMARY, GET_BRANCH_APPLICATIONS } from "../actionType";

let initialState = {
    loading: false,
    error: null,
    branchApplications: {},
    applicationsSummary: {},
    allActiveBranches: [],
};

export const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case BRANCH_APPLICATIONS_LOADER:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case BRANCH_APPLICATIONS_ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case GET_BRANCH_APPLICATIONS:
            return {
                ...state,
                loading: false,
                branchApplications: { data: [...payload.applications], pagination: payload.pagination },
                error: null,
            };
        case GET_APPLICATIONS_SUMMARY:
            return {
                ...state,
                loading: false,
                applicationsSummary: payload,
                error: null,
            };
        case GET_ALL_ACTIVE_BRANCHES:
            return {
                ...state,
                loading: false,
                allActiveBranches: payload,
                error: null,
            };
        default:
            return state;
    }
};
